var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "earth-americas-solid",
    d: "M2.7,9.047l.441.769a3,3,0,0,0,1.781,1.4l2.714.773A1.873,1.873,0,0,1,9,13.791v1.87a1.356,1.356,0,0,0,.75,1.214,1.356,1.356,0,0,1,.75,1.214v1.828a1.1,1.1,0,0,0,1.4,1.059,2.209,2.209,0,0,0,1.533-1.584l.131-.525a2.992,2.992,0,0,1,1.42-1.875l.38-.216A2.247,2.247,0,0,0,16.5,14.822v-.389a2.25,2.25,0,0,0-.661-1.589l-.183-.183A2.25,2.25,0,0,0,14.067,12h-2.02a3.028,3.028,0,0,1-1.491-.394l-1.617-.923a.973.973,0,0,1-.431-.525.943.943,0,0,1,.478-1.148l.277-.141a1.3,1.3,0,0,1,1-.07l1.088.361a.894.894,0,0,0,.97-1.42l-.637-.764A1.5,1.5,0,0,1,11.7,5.039l.736-.858a1.5,1.5,0,0,0,.164-1.72l-.113-.2c-.164-.009-.323-.014-.488-.014A9.753,9.753,0,0,0,2.7,9.047ZM21.75,12a9.732,9.732,0,0,0-1.237-4.758l-1.2.483a1.5,1.5,0,0,0-.867,1.866l.792,2.377a1.5,1.5,0,0,0,1.059.98l1.364.342A9.761,9.761,0,0,0,21.745,12ZM0,12A12,12,0,1,1,12,24,12,12,0,0,1,0,12Z",
    fill: "#c9c9c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIcon);
export default __webpack_public_path__ + "static/media/country-icon.561d1bf02afb2f4e52ca4e44d3793bca.svg";
export { ForwardRef as ReactComponent };